import { Component, Input, OnInit } from '@angular/core';
import { isEmpty } from 'lodash';
import { Pagamento, TipoValorEnum, ValorDocumento } from 'src/app/pagamento/models/pagamento';
import { ParametrosPesquisaPagamento } from 'src/app/pagamento/models/parametros-pesquisa';
import { PagamentoService } from 'src/app/pagamento/services/pagamento.service';
import { ScopedMessageService } from 'src/app/shared/services/scoped-message.service';

@Component({
  selector: 'utilizacao-detalhes',
  templateUrl: './utilizacao-detalhes.component.html',
  styleUrls: ['./utilizacao-detalhes.component.css'],
  providers: [ScopedMessageService]
})
export class UtilizacaoDetalhesComponent implements OnInit {
  @Input() public pagamento: Pagamento;
  @Input() public collapsed: boolean = true;

  public valoresDocumento: ValorDocumento[];
  public TipoValorEnum: typeof TipoValorEnum = TipoValorEnum;

  public scopeId: string;
  public initError: boolean = false;

  constructor(
    private pagamentoService: PagamentoService,
    private scopedMessageService: ScopedMessageService,
  ) { }

  public ngOnInit(): void {
    this.onCollapsedChange(this.collapsed);
    this.scopeId = this.scopedMessageService.scopeId;
  }

  public onCollapsedChange(collapsed: boolean): void {
    this.collapsed = collapsed;

    if (this.collapsed || this.valoresDocumento != null) {
      return null;
    }

    this.carregarUtilizacao();
  }

  private carregarUtilizacao(): void {
    const parametrosPesquisa = {
      numeroPagamento: this.pagamento.pgtoNrIdAr,
      numeroDocumento: this.pagamento.pgtoNr
    } as ParametrosPesquisaPagamento;
    this.pagamentoService.obterSaldosDocumento(parametrosPesquisa).subscribe({
      next: (saldos: number[]) => {
        if (isEmpty(saldos)) {
          this.scopedMessageService.showInfo('Nenhum registro encontrado');
          this.initError = true;
          return;
        }

        this.valoresDocumento = this.pagamento.valoresDocumento;

        // O índice começa no 1, devido à implementação do serviço do SIEF RDOC
        for (let i = 1; i < saldos.length; i++) {
          const ix = i - 1;

          this.valoresDocumento[ix].saldo = saldos[i];
          this.valoresDocumento[TipoValorEnum.TOTAL].saldo += saldos[i] ?? 0;
        }

        if (saldos.length === 1) {
          this.valoresDocumento[TipoValorEnum.TOTAL].mensagem = "Saldo não controlado no SIEF";
        }
      },
      error: () => {
        this.scopedMessageService.showError('Ocorreu um erro na consulta de saldos do documento');
        this.initError = true;
      }
    });
  }
}
